export function outSideClick($parse, $window) {

    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var clickOutHandler = $parse(attrs.outSideClick);

            angular.element($window).on('click', function (event) {
                if (!element[0].contains(event.target)) {
                    scope.$ctrl.searchCollapse = false;
                }
                clickOutHandler(scope, {$event: event});
                scope.$apply();
            });
        }
    };
}


// WEBPACK FOOTER //
// ./src/ui/directives/out-side-click.directive.js